import { Subject, buffer, debounceTime, concatMap } from 'rxjs';

export default class OITOpacityNavigator {
    constructor() {
        this.modelEventBuffer = {};
    }

    debounceRequests(branchId, isTransparent, opacityUpdateCallback) {
        const modelId = modelManager.getVolume(branchId)?.modelId;
        if (!modelId) {
            return;
        }

        if (!this.modelEventBuffer[modelId]) {
            this.modelEventBuffer[modelId] = new Subject();

            this.modelEventBuffer[modelId].pipe(
                buffer(this.modelEventBuffer[modelId].pipe(debounceTime(100))),
                concatMap(async (eventsToProcess) => {
                    if (
                        eventsToProcess
                            .map(event => {
                                const volume = modelManager.getVolume(event.branchId);
                                if (volume) {
                                    volume.isTransparent = event.isTransparent;
                                    return true;
                                }
                                return false;
                            })
                            .some(Boolean)
                    ) {
                        await this.updateRenderGroupForModel(modelId);
                    }
                    eventsToProcess.map(event => event.opacityUpdateCallback());
                    return eventsToProcess;
                }),
            ).subscribe((data) => {
            });
        }

        this.modelEventBuffer[modelId].next({branchId, isTransparent, opacityUpdateCallback});
    }

    async updateRenderGroupForModel(modelId) {
        const model = getModelObject(modelId);

        if (model) {
            const tempIndexArray = new Uint32Array(model.geometry.index.array.length);
            const tempSortedArray = (model.volumes).toSorted((a, b) => {
                if(a.isTransparent === b.isTransparent) {
                    return 0;
                }
                if(a.isTransparent) {
                    return 1;
                }
                return -1;
            });

            await (new Promise((resolve, reject) => {
                let index = 0;
                let arrayUpdatedLength = 0;
                const processNextBatch = (until) => {
                    while(Date.now() < until) {
                        if (index >= tempSortedArray.length) {
                            return true;
                        }
                        const vol = tempSortedArray[index];
                        if(!vol) {
                            ++index;
                            continue;
                        }

                        const startIndex = vol.startIndex;
                        const endIndex = vol.endIndex;
                        tempIndexArray.set(model.geometry.index.array.subarray(startIndex, endIndex + 1), arrayUpdatedLength);
                        arrayUpdatedLength = (endIndex - startIndex + 1) + arrayUpdatedLength;
                        ++index;
                    }
                    return false;
                };
                const onRender = () => {
                    try {
                        if (processNextBatch(Date.now() + 40)) {
                            document.removeEventListener("scene_rendered", onRender);
                            resolve();
                        }
                    }
                    catch (error) {
                        document.removeEventListener("scene_rendered", onRender);
                        reject(error);
                    }
                };
                document.addEventListener("scene_rendered", onRender);
            }));

            let opaqueLength = 0;
            let arrayUpdatedLength = 0;
            for (let i = 0; i < tempSortedArray.length; ++i) {
                const vol = tempSortedArray[i];
                if(!vol) continue;

                const startIndex = vol.startIndex;
                const endIndex = vol.endIndex;
                const newStartIndex = arrayUpdatedLength;
                const newEndIndex = (endIndex - startIndex) + arrayUpdatedLength;
                arrayUpdatedLength = (endIndex - startIndex + 1) + arrayUpdatedLength;
                if(!vol.isTransparent) {
                    opaqueLength = arrayUpdatedLength;
                }
                vol.startIndex = newStartIndex;
                vol.endIndex = newEndIndex;
            }
            model.geometry.index.array = tempIndexArray;
            model.geometry.index.needsUpdate = true;

            model.geometry.groups[0].start = 0;
            model.geometry.groups[0].count = opaqueLength;

            model.containsTransparentVolume = false;
            model.geometry.groups[1].start = 0;
            model.geometry.groups[1].count = 0;

            if (opaqueLength !== arrayUpdatedLength) {
                model.containsTransparentVolume = true;
                model.geometry.groups[1].start = opaqueLength;
                model.geometry.groups[1].count = Infinity;
            }

            wv.isTransparentMaterialActive = CADModel.modelArray.some(m => m.containsTransparentVolume);
        }
    }
}
